import "../../../../styles/page/help&support.scss";

import Icon, { iconColor, iconTypes } from "../../../common/components/Icon.jsx";
import { SubMenu, SubMenuItem } from "../../../common/components/SubMenu.jsx";

import DragAndDrop from "../../../common/components/DragAndDrop";
import DropDownList from "../../../common/components/DropDownList.jsx";
import LabelField from "../../../common/components/LabelField";
import { Localization } from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import TextArea from "../../../common/components/Textarea";
import { scssVariables } from "../../../common/util/config.jsx";

class BtnRemoveFile extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onClickRemove = this.onClickRemove.bind(this);
    }
    onClickRemove() {
        const {
            message,
            editMessage,
            file,
        } = this.props;
        editMessage({
            files: message.files.filter( (item) => item!==file),
        });
    }
    render() {
        const {
            file,
        } = this.props;
        return (
            <button className="btn-tiny icon" onClick={this.onClickRemove}> 
                <Icon type={iconTypes.x} color={iconColor.red} />
                {file.name}
            </button>
        );
    }
}
BtnRemoveFile.propTypes = {
    file: PropTypes.object.isRequired,
    message: PropTypes.object.isRequired,
    editMessage: PropTypes.func.isRequired,
};

class MessageCart extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            expanded: this.props.deviceType!=="xs",
            files: [],
        };

        this.onClickExpand = this.onClickExpand.bind(this);
        this.onClickMinimize = this.onClickMinimize.bind(this);
        this.handleFiles = this.handleFiles.bind(this);
        this.handleError = this.handleError.bind(this);
    }

    onClickExpand() {
        this.setState({
            expanded: true,
        });
    }
    onClickMinimize() {
        this.setState({
            expanded: false,
        });
    }
    handleFiles(files) {
        const {
            message,
            editMessage
        } = this.props;
        //creates a new variable to force a render()
        const f = [].concat(message.files || []);
        for(let i=0; i<files.length; i++){
            if( files[i].name ){
                f.push(files[i]);
            }
        }
        editMessage({
            files: f,
        });
    }
    handleError() {
    }

    render() {
        const {
            localization,
            height,
            deviceType,
            editMessage,
            faq,
            message,
            support,
            clearMessage,
            submitSupportMessage,
            setDropDown,
        } = this.props;

        const renderCart = () => {

            const subjects = [...new Set(faq.map(item => item.subject))];
            const options = [];

            subjects.forEach(function (element) {
                options.push(
                    {
                        value: element,
                        label: element,
                    }
                );
            });

            const isLoading = support.isLoading;
            const hasInput = !isLoading && ((message.subject && message.subject.length>0) || (message.messageInput && message.messageInput.length>0));
            const canSubmit = !isLoading && message.subject && message.subject.length>0 && message.messageInput && message.messageInput.length>0 && message;

            return (
                <React.Fragment>
                    <SubMenu>
                        <SubMenuItem
                            iconType={iconTypes.chatBubble}
                            style={{ marginLeft: "9px" }}
                            interactive={false}
                        />
                        <div className="send-message-menu-text">
                            {localization.text("help", "sendUsAMessage")}
                        </div>
                        {this.state.expanded && deviceType==="xs" && (
                            <SubMenuItem
                                iconType={iconTypes.down}
                                side="locked-right"
                                onClick={this.onClickMinimize}
                            />
                        )}
                    </SubMenu>

                    <div className="help-cart-wrapper" style={{height:height-64}}>
                        <div className="flow">
                            <div className="line">
                                <LabelField
                                    label={localization.text("help", "subject")}
                                    isRequired={true}
                                />
                                <DropDownList options={options} onEdit={editMessage} source={message} property={"subject"} value={message.subject} placeholder={localization.text("help", "selectSubject")} disabled={isLoading} setDropDown={setDropDown}/>
                            </div>
                            <div className="area">
                                <LabelField
                                    label={localization.text("help", "message")}
                                    isRequired={true}
                                />
                                <TextArea onEdit={editMessage} placeholder={localization.text("help", "typeMessageHere")} source={message} property="messageInput" className="textarea-div" classNameText="textarea" usingSubmit={true} disabled={isLoading} maxLength={8000}/>
                            </div>
                            <div className="files">
                                {message.files && message.files.map( (file) => (
                                    <BtnRemoveFile key={file.name} file={file} message={message} editMessage={editMessage} />
                                ))}
                            </div>
                            <div className="dropArea-wrapper">
                                <DragAndDrop localization={localization} handleFiles={this.handleFiles} disabled={isLoading} allowVideo={false} handleError={this.handleError}/>
                            </div>
                            <div className="bottom">
                                <button className="btn icon" disabled={!hasInput} onClick={clearMessage}>
                                    <Icon type={iconTypes.x} color={iconColor.red}></Icon>
                                    {localization.text("help", "clear")}
                                </button>
                                <button className="btn primary" disabled={!canSubmit} onClick={submitSupportMessage}>
                                    {localization.text("help", "sendMessage")}
                                </button>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        };

        return this.state.expanded ? (
            deviceType === "xs" ? (
                <React.Fragment>
                    <div className="dim-screen" onClick={this.onClickMinimize} />
                    <div
                        className="shopping-cart-card-expanded-tiny"
                        style={{
                            height: `${height + parseInt(scssVariables.cardMargin)}px`
                        }}
                    >
                        {renderCart()}
                    </div>
                </React.Fragment>
            ) : (
                <div
                    className="card-default shopping-cart-card"
                    style={{ height: `${height}px` }}
                >
                    {renderCart()}
                </div>
            )
        ) : (
            <div className="shopping-cart-card-tiny">
                <SubMenu>
                    <SubMenuItem iconType={iconTypes.chatBubble} />
                    <div className="send-message-menu-text">
                        {localization.text("help", "sendUsAMessage")}
                    </div>
                    <SubMenuItem
                        iconType={iconTypes.up}
                        side="locked-right"
                        onClick={this.onClickExpand}
                    />
                </SubMenu>
            </div>
        );
    }
}

MessageCart.propTypes = {
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    height: PropTypes.number.isRequired,
    editMessage: PropTypes.func.isRequired,
    faq: PropTypes.array.isRequired,
    support: PropTypes.object.isRequired,
    message: PropTypes.object.isRequired,
    clearMessage: PropTypes.func.isRequired,
    submitSupportMessage: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
};

export default MessageCart;
